import React, { useEffect, useState } from 'react';
import { getProjectFiles, downloadFile, ProjectFile } from '../../services/reportService';

interface ResearchProjectReportsSectionProps {
  projectId: string;
}

const ResearchProjectReportsSection: React.FC<ResearchProjectReportsSectionProps> = ({ projectId }) => {
  const [files, setFiles] = useState<ProjectFile[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadFiles = async () => {
      try {
        setLoading(true);
        setError(null);
        const projectFiles = await getProjectFiles(projectId);
        console.log('Загруженные файлы:', projectFiles);
        setFiles(projectFiles);
      } catch (err) {
        console.error('Ошибка загрузки файлов:', err);
        setError('Ошибка загрузки отчетов');
      } finally {
        setLoading(false);
      }
    };

    if (projectId) {
      loadFiles();
    }
  }, [projectId]);

  const handleFileClick = async (file: ProjectFile) => {
    try {
      await downloadFile(file);
    } catch (err) {
      console.error('Ошибка скачивания файла:', err);
      alert('Ошибка скачивания файла. Попробуйте еще раз.');
    }
  };

  // Функция форматирования даты
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${day}.${month}.${year} ${hours}:${minutes}`;
  };

  // Font Awesome иконка PDF
  const PDFIcon = () => (
    <i className="fas fa-file-pdf" style={{ fontSize: '28px', color: '#dc3545' }}></i>
  );

  if (loading) {
    return (
      <div style={{ borderRadius: 8, padding: 20, marginBottom: 16 }}>
        <h2 style={{ 
          fontSize: 24, 
          fontWeight: 600, 
          color: '#1a237e', 
          margin: 0,
          display: 'flex',
          alignItems: 'center',
          gap: 8
        }}>
          <i className="fas fa-file-alt" style={{ fontSize: '22px' }}></i>
          Отчеты
        </h2>
        <div style={{ color: '#666', marginTop: 12 }}>Загрузка отчетов...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ borderRadius: 8, padding: 20, marginBottom: 16 }}>
        <h2 style={{ 
          fontSize: 24, 
          fontWeight: 600, 
          color: '#1a237e', 
          margin: 0,
          display: 'flex',
          alignItems: 'center',
          gap: 8
        }}>
          <i className="fas fa-file-alt" style={{ fontSize: '22px' }}></i>
          Отчеты
        </h2>
        <div style={{ color: '#e74c3c', marginTop: 12 }}>{error}</div>
      </div>
    );
  }

  return (
    <div style={{ borderRadius: 8, padding: 20, marginBottom: 16 }}>
      <h2 style={{ 
        fontSize: 24, 
        fontWeight: 600, 
        color: '#1a237e', 
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        gap: 8
      }}>
        <i className="fas fa-file-alt" style={{ fontSize: '22px' }}></i>
        Отчеты
      </h2>
      {files.length === 0 ? (
        <div style={{ color: '#666', marginTop: 12 }}>Нет отчетов по данному проекту</div>
      ) : (
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 12 }}>
          {files.map((file) => (
            <div
              key={file.id}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 6,
                padding: '12px 16px',
                background: 'white',
                border: '1px solid #e0e0e0',
                borderRadius: 6,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                fontSize: 14,
                color: '#1a237e',
                minWidth: 160
              }}
              onClick={() => handleFileClick(file)}
              title={`Скачать ${file.file_name}`}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#f5f5f5';
                e.currentTarget.style.borderColor = '#dc3545';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'white';
                e.currentTarget.style.borderColor = '#e0e0e0';
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <PDFIcon />
                <span style={{ fontWeight: 600 }}>{file.file_name}</span>
              </div>
              <div style={{ fontSize: 12, color: '#666' }}>
                {formatDate(file.uploaded_at)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ResearchProjectReportsSection;
